import { Carousel } from '@components/primitives/Carousel'
import { Text } from '@components/primitives/Text'
import { parseMeasurementsFromTrial } from '@modules/trials/helpers/parseMeasurementsFromTrial'
import type { TrialAssociation } from '@modules/trials/types/TrialAssociation'
import { MeasurementsCard } from '../MeasurementRequirements/MeasurementGroup'

export const StudyObjectivesSection = ({
  trial,
}: {
  trial: TrialAssociation
}) => {
  const measurements = parseMeasurementsFromTrial(trial)

  if (measurements.length === 0) {
    return null
  }

  const primaryMeasures = measurements.filter(
    (outcome) => outcome.type === 'Primary',
  )
  const secondaryMeasures = measurements.filter(
    (outcome) => outcome.type === 'Secondary',
  )
  const other = measurements.filter((outcome) => outcome.type === 'Other')

  return (
    <div className='flex flex-col'>
      <Text
        className='text-neutral900'
        element={'h4'}
        styleName='h5'
        value='Study Objectives'
      />
      <Text
        className={'mb-1 text-neutral600'}
        value='Study objectives can provide a clearer picture of what you can expect from a treatment.'
      />
      <Carousel centerVertically={false} className='gap-4'>
        {primaryMeasures.length > 0 ? (
          <MeasurementsCard
            allGroupsExpanded={false}
            items={primaryMeasures}
            timeline='Primary study objectives'
          />
        ) : (
          <></>
        )}
        {secondaryMeasures.length > 0 ? (
          <MeasurementsCard
            allGroupsExpanded={false}
            items={secondaryMeasures}
            timeline='Secondary study objectives'
          />
        ) : (
          <></>
        )}
        {other.length > 0 ? (
          <MeasurementsCard
            allGroupsExpanded={false}
            items={other}
            timeline='Other study objectives'
          />
        ) : (
          <></>
        )}
      </Carousel>
    </div>
  )
}
